export const StorageKeys = {
  PORTFOLIO: "portfolio",
  PORTFOLIO_EDIT: "portfolioEdit",
  PORTFOLIO_DRAFT: "portfolioDraft",
  USER_ID: "userId",

  PORTFOLIO_PRESENTATION: "portfolio-{id}-presentation",
} as const;

export type StorageKeysType = (typeof StorageKeys)[keyof typeof StorageKeys];

const getFromStorage = (key: StorageKeysType | string, defaultValue = null) => {
  if (typeof window === "undefined") return null;

  const value = localStorage.getItem(key);
  return value ? JSON.parse(value) : defaultValue;
};

const setInStorage = (key: StorageKeysType | string, value: any) => {
  if (typeof window === "undefined") return null;

  const valueToStore = JSON.stringify(value);
  localStorage.setItem(key, valueToStore);
};

const removeFromStorage = (key: StorageKeysType | string) => {
  localStorage.removeItem(key);
};

const clear = () => {
  localStorage.clear();
};

export function getUserPortfolioDraftKey() {
  const userId = getFromStorage(StorageKeys.USER_ID);
  if (!userId) return null;
  return `${userId}:${StorageKeys.PORTFOLIO_DRAFT}`;
}

export const StorageService = Object.freeze({
  clear,
  get: getFromStorage,
  set: setInStorage,
  remove: removeFromStorage,
  getUserPortfolioDraftKey,
});
